import { render, staticRenderFns } from "./ModalCreateAccount.vue?vue&type=template&id=53179000&"
import script from "./ModalCreateAccount.vue?vue&type=script&lang=js&"
export * from "./ModalCreateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports